
export namespace OldCurriculum {
    export class Load {
        static readonly type = '[OldCurriculum] Load';
    }
}